import { render, staticRenderFns } from "./swiperCom.vue?vue&type=template&id=19526266&scoped=true"
import script from "./swiperCom.vue?vue&type=script&lang=js"
export * from "./swiperCom.vue?vue&type=script&lang=js"
import style0 from "./swiperCom.vue?vue&type=style&index=0&id=19526266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19526266",
  null
  
)

export default component.exports